import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';





class Promotion extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidMount() {

	}

	async componentDidUpdate() {

	}


	render() {
		const { userTheme } = this.props;
		// let poster = require('../../../src/static/AB.png' );
		return (
			<div style={{marginLeft:20}}>
			<p style={{color:userTheme === "dark"? "white" : "black" }} >Craffview specializes in promotion data analysis, offering valuable insights on how to enhance your promotion offers. Our approach involves comparing baseline analytics, analyzing promotion data, measuring return on investment (ROI), and implementing iterative improvements. By leveraging these methods, we help you create more effective promotion campaigns.</p>
			{/* <img src={poster} style={{width: '50%'}}></img> */}
			</div>
			);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	userTheme: state.user.userTheme,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Promotion);
